import type { OverlayStyles } from '../types/feature-gate-overlay-types';

// ============================================================================
// Overlay style computation (exported for testing)
// ============================================================================

export function buildOverlayStyles(visiblePercent: number): OverlayStyles {
  const vp = Math.max(0, Math.min(100, visiblePercent));

  const s1 = 10;
  const s2 = Math.round(vp * 0.5);
  const s3 = vp;
  const s4 = Math.min(vp + 12, 85);
  const s5 = Math.min(vp + 25, 92);
  const s6 = Math.min(vp + 38, 100);

  const scrimGradient = [
    'rgba(255,255,255,0) 0%',
    `rgba(255,255,255,0.04) ${s1}%`,
    `rgba(255,255,255,0.10) ${s2}%`,
    `rgba(255,255,255,0.25) ${s3}%`,
    `rgba(255,255,255,0.50) ${s4}%`,
    `rgba(255,255,255,0.80) ${s5}%`,
    `rgba(255,255,255,1) ${s6}%`,
  ].join(', ');

  return {
    scrimGradient: `linear-gradient(to bottom, ${scrimGradient})`,
  };
}
